import { Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import ItemsList from './components/ItemsList'
import ItemInformation from './components/ItemInformation'
import { useLocation } from "react-router-dom";
import { ItemInformationMobile } from './components/ItemInformationMobile';
import WebApplication from '../../../img/news-announcement/web-application.png';

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);

    const handleChange = (e) => {
      setIsMobile(e.matches);
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, [breakpoint]);

  return isMobile;
}

const Detail = () => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const { type, id, announcement, news } = location.state || {};
  const [onOpenDetail, setOnOpenDetail] = useState(0);
  const [listId, setListId] = useState(id);
  const [activeTab, setActiveTab] = useState(type)

  const imageDefault = ["Ants_LINEOA", "Ants_LON", "Ants_MMS", "Ants_SMS"]

  return (
    <div className='m-3'>
      <Row gutter={24}>
        <Col sm={24} md={8} lg={8} xl={8}>
          {onOpenDetail === 0 ?
            <ItemsList
              isMobile={isMobile}
              setOnOpenDetail={setOnOpenDetail}
              type={type}
              announcement={announcement}
              news={news}
              setListId={setListId}
              listId={listId}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              imageDefault={imageDefault}
            />
            : <ItemInformationMobile
              setOnOpenDetail={setOnOpenDetail}
              activeTab={activeTab}
              announcement={announcement}
              news={news}
              listId={listId}
              imageDefault={imageDefault}
            />
          }
        </Col>
        {!isMobile && (
          <Col md={16} lg={16} xl={16}>
            <ItemInformation
              activeTab={activeTab}
              announcement={announcement}
              news={news}
              listId={listId}
              imageDefault={imageDefault}
            />
          </Col>
        )}
      </Row>
    </div>
  )
}

export default Detail